<div *ngIf="content" [class.expanded]="expanded" (click)="expand()">
  <div class="content-title">
    <ion-icon name="chevron-{{expanded ? 'up' : 'down'}}-circle-outline"></ion-icon>
    <span [innerHTML]="content.title"></span>
  </div>
  <div [innerHTML]="content.body" class="content-body" #body [style.max-height]="maxHeight + 'px'"></div>
</div>
<div *ngIf="error" class="invalid-feedback">{{error}}</div>